<template>
    <div class="main" v-loading.fullscreen="isLoad" element-loading-background="rgba(0, 0, 0,0)">
        <el-breadcrumb>
            <el-breadcrumb-item>订单汇总</el-breadcrumb-item>
        </el-breadcrumb>

        <el-form :inline="true"  :model="item"  class="search">
            <el-form-item label="订单名称" >
                <el-input v-model="item.name" placeholder="请输入订单名称"
                          size="small"></el-input>
            </el-form-item>
            <el-form-item label="状态">
                <el-select v-model="item.shop" placeholder="状态" size="small">
                    <el-option label="已完成" value=""></el-option>
                    <el-option label="未完成" value=""></el-option>
                    <el-option label="已取消" value=""></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="时间">
                <el-date-picker
                        size="small"
                        style="margin-left: 10px"
                        v-model="value2"
                        type="datetimerange"
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期">
                </el-date-picker>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="submit" size="medium">查询</el-button>
            </el-form-item>
        </el-form>
        <div class="btns">
            <el-button type="danger" size="small" @click="">批量删除</el-button>
        </div>
        <!--		数据是list 通过list展示-->
        <el-table :data="list" border>
            <el-table-column type="selection" align="center"></el-table-column>
			<el-table-column width="60" align="center">
				<template slot-scope="scope">
					{{scope.$index + (page-1) * pageSize + 1}}
				</template>
			</el-table-column>
            <el-table-column prop="indent" label="订单号"></el-table-column>
            <el-table-column label="图片">
                <template slot-scope="scope">
                    <div style="display: flex; align-items: center;">
                        <img :src="scope.row.thumb" height="30" style="display:
                        flex;" />
                    </div>
                </template>
            </el-table-column>
            <el-table-column prop="title" label="标题"></el-table-column>
            <el-table-column prop="price" label="单价"></el-table-column>
            <el-table-column prop="number" label="数量"></el-table-column>
            <el-table-column prop="fee" label="金额"></el-table-column>
            <el-table-column prop="status" label="状态"></el-table-column>
            <el-table-column prop="date" label="创建日期"></el-table-column>
            <el-table-column label="操作">
                <template slot-scope="scope">
                    <el-button size="mini" type="primary" @click="edit(scope.row.id)">编辑</el-button>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination @size-change="sizeReload" @current-change="pageReload" :current-page="page" :page-sizes="[20, 100, 200, 300, 400]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total"></el-pagination>
    </div>
</template>
<script>
    export default {
        name: 'index',
        data() {
            return {
                list:[{
                    id:1,
                    number: "1",
                    price: '100',
                    indent: "1",
                    thumb:'https://oss.xm0592.com/user/2021/07/08/ba7b10820a9a4069ae1aee73f8548167.jpg',
                    title:'情侣装',
                    fee: 126.00,
                    status: "未完成",
                    date: "2021-07-01 17:26:42"
                },{
                    id:2,
                    number: "2",
                    price: '100',
                    indent: "2",
                    thumb:'https://oss.xm0592.com/user/2021/07/08/ba7b10820a9a4069ae1aee73f8548167.jpg',
                    title:'情侣装',
                    fee: 126.20,
                    status: "已完成",
                    date: "2021-02-01 17:26:42"
                },{
                    id:3,
                    number: "3",
                    price: '100',
                    indent: "3",
                    thumb:'https://oss.xm0592.com/user/2021/07/08/ba7b10820a9a4069ae1aee73f8548167.jpg',
                    title:'情侣装',
                    fee: 126.20,
                    status: "已取消",
                    date: "2021-02-01 17:26:42"
                }],
                isLoad:false,
                pageSize:20,
                total:0,
                page:1,
                // 查询
                item:{},
                value2:''
            }
        },
        created() {
            // this.loadList()
        },
        methods: {
            loadList(){
                if(this.isLoad)
                    return
                this.isLoad = !this.isLoad
                this.axios.post('/channelv1/list',{
                    page: this.page,
                    limit: this.pageSize
                })
                    .then(res => {
                        this.isLoad = !this.isLoad
                        // 获取数据
                        this.list = res.data.records
                        // 页数 page
                        this.total = res.data.total
                    })
                    .catch(() => {
                        this.isLoad = !this.isLoad
                    })
            },
            // 传一个ID跳转到edit页面，进行编辑
            edit(id){
                this.$router.push({
                    path:'/Indent/ownList.html',
                    query:{
                        id:id
                    }
                });
            },
            //
            del(id){
                if(this.isLoad){
                    return
                }
                this.isLoad = !this.isLoad
                this.axios.delete('/channelv1/delete', {
                    data:[
                        id
                    ]
                })
                    .then(() => {
                        this.isLoad = !this.isLoad
                        this.$message.success({
                            message: '删除成功',
                            showClose:false
                        });
                        //   this.loadList()
                    })
                    .catch(() => {
                        this.isLoad = !this.isLoad
                    })
            },
            sizeReload(val){
                this.pageSize = val
                //   this.loadList()
            },
            pageReload(val){
                this.page = val
                //   this.loadList()
            },
            // 搜索查询
            submit(){
                this.item.page = 1
                //   this.loadList()
            },
            excelOut(){
                return;
                if(this.isLoad)
                    return
                this.isLoad = !this.isLoad
                this.axios.get('',{
                    params:{
                        nickname:this.item.nickname,
                        title:this.item.title
                    }
                })
                    .then(res => {
                        this.isLoad = !this.isLoad
                        // 导出
                        window.open(res.url)
                    })
                    .catch(() => {
                        this.isLoad = !this.isLoad
                    })
            }
        }
    }
</script>
<style scoped>
</style>
